import type { App } from 'vue'
import type { Router } from 'vue-router'
import * as Sentry from '@sentry/vue'

import { DEFAULT_BACKEND_URI } from '@/opendoors-api/useClient'

export function configureSentry(sentryDSN: string, app: App, router: Router) {
  const subdomain = location.hostname.split('.', 1)[0]
  const sentryEnv = ['develop', 'localhost'].includes(subdomain)
    ? 'develop'
    : subdomain === 'staging'
      ? 'staging'
      : 'production'
  Sentry.init({
    app,
    dsn: sentryDSN,
    environment: sentryEnv,
    // Preserve the restrictive data collection defaults from Sentry v10.
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: {
        request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
        response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] }
      },
      httpBodies: [],
      // MSAL redirects back with OAuth response values in the URL query.
      urlQueryParams: { deny: ['code', 'state', 'session_state', 'client_info'] },
      genAI: { inputs: false, outputs: false },
      databaseQueryData: false,
      graphQL: { document: false, variables: false }
    },
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracePropagationTargets: [DEFAULT_BACKEND_URI],
    ...(sentryEnv != 'develop' && { tracesSampleRate: 0.2 })
  })
}
